import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import PurchasePapers from "../components/PurchasePapers";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HeroSlider from "./HeroSlider";
import Testimonials from "../components/Testimonials";
import YoutubeVideos from "../components/YoutubeVideos";
import PopupGallery from "../components/PopupGallery";
import BlogList from "../components/BlogList";


function Home() {

  

  return (
    <>
      <Header />
         <PopupGallery />

      <HeroSlider />
      <PurchasePapers />
      <Testimonials />
       <YoutubeVideos />
       <BlogList />

      <Footer />
    </>
  );
}

export default Home;